export enum TradeSide {
    Buy = 'Buy',
    Sell = 'Sell'
}
